import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Router} from '@angular/router';
import {DateRangeDto} from '../dto/DateRangeDto';
import {Observable} from 'rxjs/index';
import swal from 'sweetalert2';
import { saveAs } from 'file-saver';
import {AuditTraceDTO} from '../dto/AuditTraceDTO';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class AudittraceReportService{
  constructor(private appConfig: AppConfig, private httpClient: HttpClient, private router: Router) {
  }

  baseUrl: string = this.appConfig.getConfig('BASE_URL') + 'api/audittracereport/';
  private headersJson = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});

  searchAuditTraceData(data: DateRangeDto): Observable<Object>{
    return this.httpClient.post(this.baseUrl + 'searchAuditTraceDetails', data);
  }

  printExcelReport(dateRangeDto: DateRangeDto): any{
    return this.httpClient.post(this.baseUrl + 'printExcelReport', dateRangeDto, {headers: this.headersJson, responseType: 'blob'})
      .subscribe(res => {
        const blob = new Blob([res], {type: res.type});
        saveAs(blob, 'Audit Trace Report.xls');
        this.router.navigate(['/dashboard/dashHome']);
      },error => {
        swal.fire('Sorry!', 'File not available!', 'error');
      })
  }

  exportAsPDF(dto: AuditTraceDTO[]): Observable<Object>{
    return this.httpClient.post(this.baseUrl + 'exportAsPDF', dto, {responseType: 'arraybuffer'});
  }

  exportAsExcel(dto: AuditTraceDTO[]): Observable<Object>{
    return this.httpClient.post(this.baseUrl + 'exportAsExcel', dto, {responseType: 'arraybuffer'});
  }
}
